import * as React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent, { timelineOppositeContentClasses } from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import StatusLayout from './Status';
import moment from 'moment';
import { Collapse } from '@mui/material';


export default function HistoryComponent({ history }) {
  const [open, setOpen] = React.useState(true)
  const [index, setIndex] = React.useState(0)
  const historyList=history?.sort(
    (a, b) =>
      new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
  return (
    <Timeline
      sx={{
        [`& .${timelineOppositeContentClasses.root}`]: {
          flex: 0.2,
        },
      }}
    >
      {historyList?.map((item, key) =>
        <TimelineItem>
          <TimelineOppositeContent color="textSecondary">
            {moment(item.createdAt).format('lll')}
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot variant="outlined" color={key / 2 === 0 ? "secondary" : "primary"} />
            {/* <StatusLayout status={item.status}/> */}
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent role="button"
            onClick={() => {
              setOpen(!open || key !== index);
              setIndex(key);
            }}>{item.tag}

            <div>
              {" "}
              {!open || index !== key ? (
                <em className="text-blue-600">more</em>
              ) : (
                <em className="text-blue-600">less</em>
              )}
            </div>
            <Collapse in={open && index === key} className="p-3">
              <div className="mb-3">

                <span>Done By:&nbsp;{item.isSystemCreator ? 'Created By System' : item?.Resource?.names}</span>
              </div>
              <div className="mb-3">

                <span>Description:&nbsp;{item?.comment}</span>
              </div>
              <div>
                {" "}
                <span className="text-capitalize">
                  Status: &nbsp;  &nbsp;  <StatusLayout status={item?.status} />
                </span>
              </div>
            </Collapse>
          </TimelineContent>
        </TimelineItem>
      )}
    </Timeline>
  );
}
